import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import AltText from '@components/svgs/AltText'
import AltTextSub from '@components/svgs/AltTextSub'

import styles from './Hero.module.scss'

// In Vite, static assets in public folder are served from root
const banner = '/wolf-white.svg'

export default function Hero () {
  return (
    <Box className={styles.hero} py={4}>
      {/* LCP image - use img tag instead of background-image for better discoverability */}
      <img
        src={banner}
        alt=""
        fetchpriority="high"
        aria-hidden="true"
        className={styles.backgroundImage}
      />
      <Grid container className={styles.content}>
        <Grid item xs={12}>
          <Box className={styles.centerContainer}>
            <Box className={styles.logoContainer}>
              <AltText
                width="100%"
                height="100%"
                viewBox="0 0 3622 1298"
                fill="white"
              />
            </Box>
            <Box className={styles.subLogoContainer}>
                <AltTextSub
                  width="100%"
                  viewBox="0 0 1289 262"
                  fill="white"
                />
              </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  )
}
